<section class="scraii-admin-create-modal-dialog-root">
 
    <!-- ============ HEADER ============ -->
    <div class="scraii-admin-create-modal-dialog-header mb-2">
        <div class="scraii-admin-create-modal-dialog-title">
            {{ this.selectedUserForm.employee_key ? 'Update a User' : 'Create a User' }}
        </div>
 
        <button class="dialog-header-close" mat-icon-button (click)="dialogRef.close()">
            <mat-icon style="color: #1b2b4b;">close</mat-icon>
        </button>
    </div>
  
    <!-- ============ User Registration ============ -->
    <ng-container>
        <mat-dialog-content id="scraii_create_modal_content_id">
 
            <form [formGroup]="userForm" class="flex-grow-1 d-flex flex-column">
 
                <!-- Row 1: Task Name / Task Type / Assign To -->
                <div class="d-flex mt-2 flex-wrap">
 
                    <div class="col-12 mb-2 mb-md-0">
                        <mat-label>Email</mat-label>
                        <mat-form-field appearance="outline" class="full-width">
                            <input matInput formControlName="usr_email_id" />
                        </mat-form-field>
                    </div>
                    
                    <div class="col-12 mb-2 mb-md-0">
                        <mat-label>First Name</mat-label>
                        <mat-form-field appearance="outline" class="full-width">
                            <input matInput formControlName="usr_fst_nm" />
                        </mat-form-field>
                    </div>

                    <div class="col-12 mb-2 mb-md-0">
                        <mat-label>Last Name</mat-label>
                        <mat-form-field appearance="outline" class="full-width">
                            <input matInput formControlName="usr_lst_nm" />
                        </mat-form-field>
                    </div>
                    
                    <div class="col-12 mb-2 mb-md-0">
                        <mat-label>Gender</mat-label>
                        <mat-form-field appearance="outline" class="full-width">
                            <mat-select formControlName="gender">
                                <mat-option *ngFor="let t of ['M', 'F']" [value]="t">
                                    {{ t }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="d-flex mt-2 flex-wrap">
 
                        <div class="col-12 mb-2 mb-md-0">
                            <mat-label>Start Date</mat-label>
                            <mat-form-field appearance="outline" class="full-width">
                                <input matInput readonly [matDatepicker]="startPicker" formControlName="start_date">
                                <mat-datepicker-toggle matSuffix [for]="startPicker">
                                    <mat-icon matDatepickerToggleIcon>
                                        <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12.75 6.08333H0.75M9.41667 0.75V3.41667M4.08333 0.75V3.41667M3.95 14.0833H9.55C10.6701 14.0833 11.2302 14.0833 11.658 13.8653C12.0343 13.6736 12.3403 13.3676 12.532 12.9913C12.75 12.5635 12.75 12.0034 12.75 10.8833V5.28333C12.75 4.16323 12.75 3.60318 12.532 3.17535C12.3403 2.79903 12.0343 2.49307 11.658 2.30132C11.2302 2.08333 10.6701 2.08333 9.55 2.08333H3.95C2.8299 2.08333 2.26984 2.08333 1.84202 2.30132C1.46569 2.49307 1.15973 2.79903 0.967987 3.17535C0.75 3.60318 0.75 4.16323 0.75 5.28333V10.8833C0.75 12.0034 0.75 12.5635 0.967987 12.9913C1.15973 13.3676 1.46569 13.6736 1.84202 13.8653C2.26984 14.0833 2.8299 14.0833 3.95 14.0833Z"
                                                [attr.stroke]="this.selectedUserForm?.start_date ? (this.selectedUserForm.employee_key ? '#ddd' : '#1363DF') : '#1363DF'" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                    </mat-icon>
                                </mat-datepicker-toggle>
                                <mat-datepicker #startPicker></mat-datepicker>
                            </mat-form-field>
                        </div>
    
                        <div class="col-12 mb-2 mb-md-0">
                            <mat-label>End Date</mat-label>
                            <mat-form-field appearance="outline" class="full-width">
                                <input matInput readonly [matDatepicker]="endPicker" [min]="userForm.get('start_date')?.value" formControlName="end_date">
                                <mat-datepicker-toggle matSuffix [for]="endPicker">
                                    <mat-icon matDatepickerToggleIcon>
                                        <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12.75 6.08333H0.75M9.41667 0.75V3.41667M4.08333 0.75V3.41667M3.95 14.0833H9.55C10.6701 14.0833 11.2302 14.0833 11.658 13.8653C12.0343 13.6736 12.3403 13.3676 12.532 12.9913C12.75 12.5635 12.75 12.0034 12.75 10.8833V5.28333C12.75 4.16323 12.75 3.60318 12.532 3.17535C12.3403 2.79903 12.0343 2.49307 11.658 2.30132C11.2302 2.08333 10.6701 2.08333 9.55 2.08333H3.95C2.8299 2.08333 2.26984 2.08333 1.84202 2.30132C1.46569 2.49307 1.15973 2.79903 0.967987 3.17535C0.75 3.60318 0.75 4.16323 0.75 5.28333V10.8833C0.75 12.0034 0.75 12.5635 0.967987 12.9913C1.15973 13.3676 1.46569 13.6736 1.84202 13.8653C2.26984 14.0833 2.8299 14.0833 3.95 14.0833Z"
                                                stroke="#1363DF" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                    </mat-icon>
                                </mat-datepicker-toggle>
                                <mat-datepicker #endPicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="col-12 mb-2 mb-md-0">
                        <mat-label>User Type</mat-label>
                        <mat-form-field appearance="outline" class="full-width">
                            <mat-select formControlName="user_type_id">
                                <mat-option *ngFor="let a of getUserType" [value]="a['USER_TYPE_ID']">
                                    {{ a['USER_TYPE_NM'] }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
 
                </div>
            </form>
 
        </mat-dialog-content>
 
        <!-- FOOTER BUTTONS -->
        <mat-dialog-actions align="end" class="gap-2 mt-2">
            <button class="scraii-secondary-btn" type="button" (click)="dialogRef.close()">
                {{ 'Cancel' }}
            </button>
 
            <button class="scraii-primary-btn" type="submit" [disabled]="userForm.invalid" (click)="onSubmit()">
                {{ this.selectedUserForm.employee_key ? 'Update' : 'Create' }}
            </button>
        </mat-dialog-actions>
 
    </ng-container>
 
</section>
 